var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[(_vm.$mq == 'sm')?_c('h2',[_vm._v(_vm._s(_vm.titulo))]):_c('h1',[_vm._v(_vm._s(_vm.titulo))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }